// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // api: 'https://testapi.creditwallet.ng/api/v2/',
  api: 'https://api.princeps.africa/api/v2/',
  // api: 'https://evasive-start-beta.antqube.io/api/v2/',
  // api: 'https://api.princeps.cloud/api/v2/',
  // api: 'https://test.princeps.cloud/staffportal-api/api/v2/',

  // domain: 'princeps.cloud',
  domain: 'creditwallet.ng',
  // oAuthUrl: 'https://intranet.princeps.cloud/login?service=marketing',
  // oAuthUrl: 'https://intranet.creditwallet.ng/login?service=marketing',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
